var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"detailmain",staticClass:"research main-page"},[_c('div',{staticClass:"researchbg"}),_c('div',{staticClass:"researchtxt",staticStyle:{"z-index":"1"},domProps:{"innerHTML":_vm._s(_vm.reportinfo.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }